<!--
 * @Author: 曹捷
 * @Date: 2021-01-08 16:38:54
 * @LastEditors: 曹捷
 * @LastEditTime: 2022-04-15 15:14:55
 * @Description: fileContent
-->
<template>
  <div class="sass-home scrollBar">
    <div class="notice flex-l-r ">
      <div class="welcome flex-c">
        欢迎登录
        <i class="iconfont icon-wujiaoxing p-l-15"></i>
      </div>
      <a href="" class="help"> <i class="iconfont icon-questionfill"></i> 帮助</a>
    </div>
    <a-row :gutter="16" class="home-content">
      <!-- <a-col class="h100" :span="12">
        <div class="home-charts">
          <div class="home-data">
            <a-card title="数据实时采集量" class="  chart-card" :bordered="false" hoverable>
              <collectDataVue></collectDataVue>
            </a-card>
          </div>
          <div class="chart-pies">
            <a-row :gutter="16" class="h100">
              <a-col class="" :span="12">
                <a-card title="设备使用率" class=" chart-card" :bordered="false" hoverable>
                  <deviceUseVue></deviceUseVue>
                </a-card>
              </a-col>
              <a-col class="" :span="12">
                <a-card title="设备故障率" class=" chart-card" :bordered="false" hoverable>
                  <deviceErrorVue></deviceErrorVue>
                </a-card>
              </a-col>
            </a-row>
          </div>
        </div>
      </a-col> -->
      <a-col class="" :span="24">
        <a-card title="帮助中心" class="h100" :bordered="false" hoverable>

          <p class="p-t-30" style="font-size:24px;">在线帮助中心</p>
          <p>如果想查看使用帮助，可点击文档按钮下载本地使用手册。</p>
          <p class="p-t-10">
            <a-button type="primary" @click="downloadOperatDocuments">下载操作文档</a-button>
          </p>
          <p class="t-c p-t-20">
            <img src="@/assets/images/home1.png" alt="">
          </p>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { inject, reactive, toRefs, onMounted, getCurrentInstance } from 'vue'
import collectDataVue from './home/collectData.vue'
import deviceUseVue from './home/deviceUse.vue'
import deviceErrorVue from './home/deviceError.vue'


export default {
  components: { collectDataVue, deviceUseVue, deviceErrorVue },
  name: 'home',
  setup (props, context) {
    let { proxy } = getCurrentInstance()
    let _data = reactive({
      fileKey: 'saas/saasCenter/2021/12-9/201127f4-a869-4d11-868e-c2318847bc18.jpg'
    })
    // let minio = inject('minio')
    // minio.parseFile('saas/template_ptag.xlsx').then(res => {

    // })
    let _methods = {
      async downloadOperatDocuments () {
        let fileUrl = await proxy.uploadSDK.parseFile('template/template_manual.pdf')
        window.open(fileUrl, "_blank")
      }
    }
    return {
      ...toRefs(_data),
      ..._methods,
    }
  },
}
</script>
<style lang="less">
.sass-home {
  height: 100%;
  width: 100%;
  padding: 0 30px;
  .notice {
    align-items: center;
  }
  .welcome {
    font-size: 24px;
    color: #fff;
    padding-top: 40px;
    padding-bottom: 50px;
    .iconfont {
      color: #616161;
    }
    .help {
      color: #2e77d0;
    }
  }
  .home-content {
    height: 650px;
    width: 100%;
    margin-bottom: 30px;
  }
  .home-charts {
    display: flex;
    flex-direction: column;
    height: 100%;
    .home-data {
      height: 300px;
      width: 100%;
    }
    .chart-pies {
      flex: 1;
      min-height: 0;
      padding-top: 16px;
    }
  }
}
.chart-card {
  height: 100%;
  display: flex;
  flex-direction: column;
  .ant-card-body {
    flex: 1;
    min-height: 0;
    padding: 0;
  }
}
</style>
